import * as React from 'react';

export type Props = {
    srcSet?: string;
    mainImage?: string;
};

export default function Srcset(props: Props) {
    const { srcSet, mainImage } = props;
    return (
        <img
            id="simg"
            style={{ position: 'fixed', visibility: 'hidden', top: '0px' }}
            data-distribution-srcset
            data-src={mainImage}
            sizes="100vw"
            srcSet={srcSet}
        />
    );
}
